



















import { defineComponent } from 'vue-demi';
//@ts-ignore
import theme from '@zk/theme/lib/variables.scss';
export default defineComponent({
  name: 'ImageCard',
  bemNS: theme.bemNS,
  components: {

  },
  props: {
    title: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  setup() {

    return {

    };

  }
});
